import { configureStore } from "@reduxjs/toolkit";
import productsReducer from "../features/products/productsSlice";
import filterReducer from "../features/filter/filterSlice";
import categoriesReducer from "../features/categories/categoriesSlice";
import reviewsReducer from "../features/reviews/reviewsSlice";
import ordersReducer from "../features/order/ordersSlice";
import citiesReducer from "../features/cities/citiesSlice";

export const store = configureStore({
  reducer: {
    products: productsReducer,
    filter: filterReducer,
    categories: categoriesReducer,
    reviews: reviewsReducer,
    orders: ordersReducer,
    cities: citiesReducer,
  },
});
